import type { BoxProps } from "@mui/material";
import { useTheme } from "@mui/material";
import { useMemo } from "react";
import HtmlPreview from "../html/HtmlPreview";
import { renderMarkdown } from "./renderMarkdown";

interface Props {
  content: string;
  containerProps?: BoxProps;
  openLinksInNewTab?: boolean;
  withoutImages?: boolean;
  webLinksOnly?: boolean;
  isLinkHidden?: (href: string) => boolean;
}

const MarkdownPreview = ({
  content,
  containerProps,
  openLinksInNewTab,
  withoutImages,
  webLinksOnly,
  isLinkHidden,
}: Props) => {
  const theme = useTheme();

  const html = useMemo(
    () => renderMarkdown(content, { openLinksInNewTab, withoutImages, webLinksOnly, isLinkHidden }),
    [content, openLinksInNewTab, withoutImages, webLinksOnly, isLinkHidden]
  );

  const extraStyles = useMemo(
    () => `
      p + p { margin-top: 6px; }
      table { margin: 4px 0; border-collapse: collapse; width: 100%; }
      th, td { border: 1px solid ${theme.palette.divider}; padding: 4px 8px; }
      th { background: ${theme.palette.action.hover}; }
    `,
    [theme]
  );

  return <HtmlPreview htmlContent={html} containerProps={containerProps} extraStyles={extraStyles} />;
};

export default MarkdownPreview;
